import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DialogBox, WaitingScreenModel } from './model';
import { ConstantData } from './constants';

@Injectable({
  providedIn: 'root'
})
export class DialogBoxService {
  private defaultValue:DialogBox = {
    title: '',
    text1: '',
    text2: '',
    text3:'',
    callBack: '',
    onClose: '',
    showNoBtn: true,
    showYesBtn: true,
    show: false,
    isDisbursed: false,
    isValidating:false
  };
  private waitingScreeDefault = { status: ConstantData.waitingScreenStatus.selfieUploading, isShow: false, isHome:true };
  private dialoagData = new BehaviorSubject<DialogBox>(this.defaultValue);
  dialoagState = this.dialoagData.asObservable();
  private eligibilityDialog = new BehaviorSubject<boolean>(false);
  eligibilityDialogState = this.eligibilityDialog.asObservable();
  private waitingDialog = new BehaviorSubject<WaitingScreenModel>(this.waitingScreeDefault);
  waitingDialogState = this.waitingDialog.asObservable();


  constructor() { }
  /**
    * method to show the dialog box
    * @param title - string - Title of the dialogb ox
    * @param callBack - callback function - it will call when user click on the yes/continue
    * @param onClose - callback function - it will call when user click on close icon or no button
    * @param showNoBtn - boolean - to show/hide  no button
    * @param showYesBtn - boolean -  to show/hide  yes button
    * @param text1 - string - to show the text message below the dialog box title
    * @param text2 - string - to show the highlighted text 
    * @param noBtnTxt - string - text that you want to show in no/cancel button
    * @param yesBtnTxt - string - text that you want to show in yes/continue button
    */
  show(title: string, callBack: any, onClose: any, showNoBtn: boolean = true, showYesBtn: boolean = true, text1?: string, text2?: string, text3? : string,
    noBtnTxt?: string,
    yesBtnTxt?: string,isDisbursed:boolean = false , isValidating:boolean = false, icon?:string) {
    this.dialoagData.next({
      title,
      callBack,
      onClose,
      showNoBtn,
      showYesBtn,
      text1: text1 || '',
      text2: text2 || '',
      text3: text3 || '',
      noBtnTxt,
      yesBtnTxt,
      show: true,
      isDisbursed: isDisbursed,
      isValidating:isValidating,
      icon:icon,
    });

  }

  // to hide the dialog box 
hide() {
    this.dialoagData.next({
      ...this.defaultValue,
      show: false,
    });

  }


  showEligibilityDialog() {
    this.eligibilityDialog.next(true);
  }
  hideEligibilityDialog() {
    this.eligibilityDialog.next(false);
  }

  showwaitingDialog(status?: string) {
    this.waitingDialog.next({ status: status || this.waitingScreeDefault.status, isShow: true, isHome:true });
  }
  hidewaitingDialog(isHome:boolean = true) {
    this.waitingDialog.next({...this.waitingScreeDefault, isHome:isHome});
  }







}
